import { Form, type FormRule } from "antd";
import { useIntl } from "react-intl";
import type { EditFixtureForm, EditFixtureFormKeys, FixtureEntrantTransformed } from "~pages/Fixtures/types";

export const useExternalIdValidator = (fieldBaseName: EditFixtureFormKeys) => {
  const form = Form.useFormInstance<EditFixtureForm>();

  const { formatMessage } = useIntl();

  const rules: FormRule[] = [
    {
      validator: (_, value) => {
        const entrants: FixtureEntrantTransformed[] = form.getFieldValue(fieldBaseName);
        const allNonEmptyExternalIds = entrants.map((entity) => entity.externalId).filter(Boolean);

        const allDuplicateExternalIds = allNonEmptyExternalIds.filter((externalId, index, self) => self.indexOf(externalId) !== index);

        if (allDuplicateExternalIds.includes(value)) {
          return Promise.reject(
            formatMessage({
              id: "form.validation.unique.externalId",
            }),
          );
        }

        return Promise.resolve();
      },
    },
  ];

  return rules;
};
